import React, { useEffect, useState } from 'react'
import './products.css'

import BtnWhatsapp from '../../components/BtnWhatsapp/BtnWhatsapp'
import CardProduct from '../../components/CardProduct/CardProduct'
import Footer from '../../components/Footer/Footer'
import Header from '../../components/Header/Header'

import ArrowBlack from '../../assets/icons/arrow-black.svg'
import RectangleExample from '../../assets/rectangle.svg'
import { productService } from '../../services/product.service'
import { categoryService } from '../../services/category.service'
import useSeo from '../../hooks/useSeo'
const Products = () => {
  const [socials] = useState({
    wpp: 'https://api.whatsapp.com/send?phone=5491161670393&text=Hola%2C+buenas+tardes%21+Tengo+una+consulta',
    ig: 'https://www.instagram.com/colibri_premium/',
    fb: ''
  })

  // Los filtros salen de la base: si se agrega o se borra una categoría desde
  // el panel, el listado se actualiza solo.
  const [filters, setFilters] = useState([])
  const [loader, setLoader] = useState(false)
  const [productsOriginal, setProductsOriginal] = useState([])
  const [products, setProducts] = useState([])

  const [pages, setPages] = useState(0)
  const [pageActual, setPageActual] = useState(1)

  const [filterActual, setFilterActual] = useState([])

  const filterProduct = filter => {
    let copyFilter = [...filterActual]

    const filterExists = copyFilter.filter(copyF => copyF === filter)

    if (filterExists.length > 0) {
      const removeFilter = copyFilter.filter(copyF => copyF !== filter)
      setFilterActual(removeFilter)
    } else {
      copyFilter.push(filter)

      setFilterActual(copyFilter)
    }
  }

  const getCategories = async () => {
    const response = await categoryService.getAllCategories()
    if (response.status === 200 && Array.isArray(response.data)) {
      setFilters(response.data)
    }
  }

  const getProducts = async () => {
    setLoader(false)
    const response = await productService.getAllProducts(
      pageActual,
      process.env.REACT_APP_CANT_PRODUCTS
    )
    if (response.status === 200) {
      setProducts(response.data.productos)
      setPages(response.data.cantPaginas)
    }
    setTimeout(() => {
      setLoader(true)
    }, 800)
  }

  const getProductByCategory = async () => {
    setLoader(false)
    const response = await productService.getProductsByCategory(
      filterActual,
      pageActual
    )

    if (response.status === 200) {
      setProducts(response.data.productos)
      setPages(response.data.cantPaginas)
    }
    setTimeout(() => {
      setLoader(true)
    }, 800)
  }
  useSeo({
    titulo: 'Accesorios para iPhone, Mac y iPad',
    descripcion:
      'Cables, cargadores, fundas y auriculares para dispositivos Apple. Comprá online con envío en Capital Federal y pagá con Mercado Pago, tarjeta o transferencia.',
    ruta: '/productos'
  })

  useEffect(() => {
    getCategories()
  }, [])
  useEffect(() => {
    // hacer consulta a la base de datos con estos productos en esta pagina.

    if (filterActual.length > 0) {
      getProductByCategory()
    } else {
      getProducts()
    }
  }, [pageActual])

  useEffect(() => {
    if (filterActual.length > 0) {
      getProductByCategory()
    } else {
      setPageActual(1)
      //buscamos todos los productos devuelta
      getProducts()
    }
  }, [filterActual])
  return (
    <div className='products'>
      <Header />
      <div className='container-products'>
        <BtnWhatsapp linkWpp={socials.wpp} />

        <h1 className='animate__animated animate__fadeIn animate__delay-01s'>
          Productos
        </h1>

        <div className='filters-products'>
          <div className='filters'>
            <h2 className='animate__animated animate__fadeIn animate__delay-02s'>
              Filtros
            </h2>
            {filters.map((filter, keyFilter) => (
              <div
                key={filter.id}
                className={`filter-item animate__animated animate__fadeIn animate__delay-0${
                  keyFilter + 1
                }s`}
              >
                <input
                  type='checkbox'
                  name='filter'
                  id={`filtro-${filter.id}`}
                  value={filter.nombre}
                  checked={filterActual.includes(filter.nombre)}
                  onChange={() => filterProduct(filter.nombre)}
                />
                <label htmlFor={`filtro-${filter.id}`}>{filter.nombre}</label>
              </div>
            ))}
          </div>
          <div className='section-products'>
            {products.length > 0 && (
              <div className='list-products'>
                {products.map((product, keyProducto) => (
                  <CardProduct
                    key={keyProducto}
                    product={product}
                    conLink={false}
                  />
                ))}
              </div>
            )}
            {/* El mensaje recién se muestra con la consulta ya resuelta, para que
            no aparezca por un instante mientras los productos están cargando. */}
            {loader && products.length === 0 && (
              <div className='empty-products'>
                <p>
                  {filterActual.length === 0
                    ? 'No hay productos disponibles por el momento'
                    : 'No hay productos que coincidan con los filtros elegidos'}
                </p>
              </div>
            )}
            {products.length > 0 && (
              <div className='pagination'>
                {pageActual !== 1 && (
                  <button
                    className='arrows'
                    onClick={() => setPageActual(pageActual - 1)}
                    disabled={pageActual === 1}
                  >
                    <img src={ArrowBlack} alt='' />
                  </button>
                )}
                {Array.from({ length: pages }).map((_, keyPage) => (
                  <div
                    key={keyPage}
                    className={`page-item ${
                      pageActual === keyPage + 1 ? 'focus' : ''
                    }`}
                    onClick={() => setPageActual(keyPage + 1)}
                  >
                    <h5>{keyPage + 1}</h5>
                  </div>
                ))}

                {pages > 1 && (
                  <button
                    className='arrows'
                    onClick={() => setPageActual(pageActual + 1)}
                    disabled={pageActual === pages}
                  >
                    <img src={ArrowBlack} alt='' />
                  </button>
                )}
              </div>
            )}
          </div>
        </div>
        <div className='tyc'>
          <h2>Términos y Condiciones</h2>
          <div className='card-tyc'>
            <h3>Garantía de Accesorios</h3>
            <p>
              Los accesorios como cables de carga o cargadores/Adaptadores
              cuentan con 30 días de garantía, siempre y cuando no presenten
              daños físicos y se devuelvan en su estado original con la caja. Al
              utilizar los servicios de Colibri Premium Service, aceptas y
              reconoces que has leído y comprendido todos los términos y
              condiciones aquí mencionados. Este consentimiento informado tiene
              como objetivo garantizar una relación transparente y confiable
              entre nosotros y nuestros valiosos clientes,nos comprometemos a
              brindarte una experiencia transparente y satisfactoria. ¡Gracias
              por confiar en nosotros para todas tus necesidades!
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default Products
